export default __webpack_public_path__ + "static/bariol_serif_bold_italic-webfont-ef9e393950fc288b044f9e47efafb7c7.woff2";